const Builder = require('../BuilderBase');

module.exports = class ToBoolean extends Builder {
    constructor(properties) {
        super('transform_ToBoolean', '', properties);
    }
};
